import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, AlertTitle, Button } from '@mui/material';

/**
 * Cross-page banner shown when a Pro provider has not yet completed PayPal
 * payout onboarding. Renders at the layout level (Dashboard.js) so it appears
 * on every tab without being duplicated per page.
 *
 * Only shown when:
 *   - provider.isProPlan === true   (Free providers can't take bookings anyway)
 *   - provider.paypalOnboardingStatus !== 'COMPLETED'
 */
const PayoutOnboardingBanner = ({ providerData, onNavigateToPayments }) => {
  const { t } = useTranslation();

  const shouldShow =
    providerData?.isProPlan === true &&
    providerData?.paypalOnboardingStatus !== 'COMPLETED';

  if (!shouldShow) return null;

  return (
    <Alert
      severity="warning"
      sx={{ mb: 2 }}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={onNavigateToPayments}
          sx={{ whiteSpace: 'nowrap' }}
        >
          {t('payoutBanner.action')}
        </Button>
      }
    >
      <AlertTitle>{t('payoutBanner.title')}</AlertTitle>
      {t('payoutBanner.body')}
    </Alert>
  );
};

export default PayoutOnboardingBanner;
